import { Link } from "react-router-dom";
import { ArrowLeft, Shield, Check } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import DemoForm from "../components/DemoForm";

export default function BookDemoPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <section className="pt-24 pb-20 lg:pt-32 lg:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Left - Info */}
            <div>
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8"
              >
                <ArrowLeft size={16} />
                Back to Home
              </Link>

              <h1 className="text-3xl sm:text-4xl font-bold text-foreground leading-tight">
                Book Your{" "}
                <span className="text-forest-500">Personalized Demo</span>
              </h1>

              <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
                See how CompostDeveloper can replace your manual tracking with an automated, compliance-ready system. Our team will walk you through the platform tailored to your facility.
              </p>

              <div className="mt-10 space-y-6">
                <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider">
                  What you'll get
                </h3>

                {[
                  "30-minute guided walkthrough of the platform",
                  "Customized to your facility size and workflow",
                  "Compliance feature deep-dive (131\u00b0F / 15-day tracking)",
                  "Live Q&A with our composting technology team",
                  "Custom pricing based on your team size",
                ].map((item) => (
                  <div key={item} className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-forest-900/50 flex items-center justify-center mt-0.5">
                      <Check size={12} className="text-forest-500" />
                    </div>
                    <p className="text-sm text-muted-foreground">{item}</p>
                  </div>
                ))}
              </div>

              <div className="mt-10 p-4 bg-card border border-border rounded-lg">
                <div className="flex items-center gap-3">
                  <Shield className="text-forest-500" size={20} />
                  <div>
                    <p className="text-sm font-medium text-foreground">No commitment required</p>
                    <p className="text-xs text-muted-foreground">See the platform, ask questions, decide on your own time.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right - Form */}
            <div>
              <div className="bg-card border border-border rounded-xl p-8">
                <h2 className="text-xl font-semibold text-foreground mb-6">Request a Demo</h2>
                <DemoForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
